import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToolbarButtonComponent } from '../../../core/buttons/toolbar-button.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';
import { dialogPaginatorDropdownStyles } from '../../../core/table/dialog-paginator-dropdown.styles';

@Component({
  selector: 'app-claim-numbers',
  standalone: true,
  host: {
    '[class.dialog-table-paginator-dropdown-self]':
      "paginatorDropdownAppendTo === 'self'",
  },
  imports: [TableComponent, ColumnComponent, ToolbarButtonComponent],
  template: ` <app-table
    [dataSource]="dataSource"
    recordLabel="claim"
    [showSelection]="showSelection"
    selectionKey="claimNumber"
    dataKey="claimNumber"
    [pageSize]="5"
    [paginatorDropdownAppendTo]="paginatorDropdownAppendTo"
    [isRowSelectable]="isRowSelectable"
    (selectedEvent)="onSelectedChanged($event)"
    [loading]="loading"
  >
    <app-column name="claimNumber" label="Claim">
      <ng-template let-data>
        <b>{{ data.claimNumber }}</b>
      </ng-template>
    </app-column>
    <app-column name="lastName" label="Last name" />
    <app-column name="firstName" label="First name" />
    <app-column name="lossDate" label="Date of loss" format="d" />
    @if (showRemove) {
      <app-column name="action" label="Remove">
        <ng-template #value let-data>
          <app-toolbar-button
            type="Compact"
            icon="fa-light fa-trash-can"
            (click)="remove(data)"
            ariaLabel="Remove claim number"
          />
        </ng-template>
      </app-column>
    }
  </app-table>`,
  styles: dialogPaginatorDropdownStyles,
})
export class ClaimNumbersComponent {
  @Input()
  dataSource: any[] = [];

  @Input()
  paginatorDropdownAppendTo: 'body' | 'self' = 'body';

  @Input()
  showRemove = true;

  @Input()
  showSelection = false;

  @Input()
  loading = false;

  @Input()
  isRowSelectable: (row: any) => boolean = () => true;

  @Output()
  selected = new EventEmitter<any[]>();

  @Output()
  removed = new EventEmitter<any>();

  onSelectedChanged(event: any[]) {
    this.selected.emit(event);
  }

  remove(row: any) {
    this.removed.emit(row);
  }
}
